var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlTvIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_2767_985",
    transform: "translate(0 0.1) scale(0.00555556)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_2767_985",
    width: 180,
    height: 144,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAALQAAACQCAYAAACh8EESAAAACXBIWXMAAEJwAABCcAFu8l9tAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAR5SURBVHgB7dy9chtVAIbh76xlOmZ8CXLLUCh3YIaKCmuwSRgKiytIaGmspKLDzg3YqQgTZ1ZMGjqHK8AUgdLiClDHTBzvco6Mh/HvbiaOtPv5fWbs0c9RYfv10dmzkoKqrOZLWsw2pNCTypV4S1fA7BwohHFsb6TXxc8a9SfXDQ5X3pNCXtBQWYpZSwLmbxzjjmEfb8ewx5cNuDzouy/uqyiGImQ00zj2+a2e90fn78guDP3yxWYcvCViRnN148ohn7Z6zsKZa2lAOZ2ZgRaIx3Qffy29+vHX01v+X3Ks54M4Ye8IaJuy+ER7/Zfp4knQ9/KujrN9sYOBdproqFhOOyAna+g3cTeDmNFeS+roQboQ/pudDwW023SW7uhYK7UfUhYP42y+e9UeIHCj1vOeyjjzhum5kCrxBKBWg9ZGedysXq0eX9zRs/6BgFmrvWERduMaOnQrx6WZmZgxL8/6u/HcyHb1wHIli6voXuW4tMwA5mlRWzVGLWWqgzUz5u1prQZrBg20BEHDCkHDCkHDCkHDCkHDCkHDCkHDCkHDCkHDCkHDCkHDCkHDCkHDCkHDCkHDCkHDCkHDCkHDCkHDCkHDCkHDCkHDCkHDCkHDCkHDCkHDCkHDCkHDCkHDCkHDCkHDCkHDCkHDCkHDCkHDCkHDCkHDCkHDCkHDCkHDCkHDCkHDCkHDCkHDCkHDCkHDCkHDCkHDCkHDCkHDCkHDCkHDCkHDCkHDCkHDCkHDCkHDCkHDCkHDCkHDCkHDCkHDCkHDCkHDCkHDCkHDCkHDCkHDCkHDCkHDCkHDCkHDCkHDCkHDCkHDCkHDCkHDCkHDCkHDCkHDCkHDCkHDCkHDCkHDCkHDCkHDCkHDCkHDCkGjHcqy1rB6Qa/mXQHz9NWoW2dYDLocV47qaCBgXjY3paIzqDHyIFOpg8phIbvPLI2ZS8uM4b70R++OymKzcnwo/gpayx/EYH9QtUl8wEO91kij/liYrcF+0G0zmXT1QWejVsxJ0CDEmXdJi9nfAtruqFzO4mw7if8BTwS0WtjRaHV8ssvR0VBpSQG001hHxaN04STop3FNXMb1MdA+ZWx3O83O6crZA421fDceIG4IaIcU8yPt9YenN5w9sbLXH6iItQPNdyHmZOHCsD9/+kUf3Q0KYUVA86Rz4Gkj47sY8/fn77x6b/NePJHyJh4ssgRBM5yG/Dh2uTXdnbtE9WZ9CvtYKyrD5/FaN87cPeEm1Hu1ze0Woy1TuC9jqr/HnYwnV4V86vadfZqFtTw9s113duvS9R/eHS8fhRWChhWChhWChhWChhWChhWCvmnpHRaYG4KGFYKGFYKGFYKGFYKGFYKGFYKGFYKGFYKGlY5wvbf9CK5X0+/1HtPmj/f68B/p8WelQrN+hOb9QtfzXnzi2ImXeKtXsx3qqPhUo/6hGqSBS44sFzG3wbIWs+dqmCauobtCWzRu4uGgEFYIGlYIGlYIGlaaGDSfU90ejdqyS5oXdFF8o/QB1u9Xydc7fpXlb/GP9YUa5l/X6UUmFvtz9AAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlTvIcon);
export default __webpack_public_path__ + "static/media/GL-tv-icon.76793f9f70e7989b00f7a622ea8a2bc9.svg";
export { ForwardRef as ReactComponent };